export default __webpack_public_path__ + "static/media/NZ.06845d78.svg";